__turbopack_context__.v({
  "block": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__block",
  "block2": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__block2",
  "caseStudyBanner": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__caseStudyBanner",
  "caseStudyBannertype_meharry": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__caseStudyBannertype_meharry",
  "caseStudyBannertype_uconn": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__caseStudyBannertype_uconn",
  "caseStudyBannertype_usc": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__caseStudyBannertype_usc",
  "desc": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__desc",
  "desc2": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__desc2",
  "desktop": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__desktop",
  "img": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__img",
  "imgtype_meharry": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__imgtype_meharry",
  "imgtype_uconn": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__imgtype_uconn",
  "quoteLogo": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__quoteLogo",
  "stats": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__stats",
  "title2": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__title2",
  "titleContainer": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__titleContainer",
  "top2": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__top2",
  "val": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__val",
  "val2": "PlasmicHomeCaseStudiesSectionBanner-module___rZ6iG__val2",
});
